import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=6732a150&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=ts"
export * from "./ChatBubble.vue?vue&type=script&lang=ts"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=6732a150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732a150",
  null
  
)

export default component.exports